import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {MAPS_EXPORT_MAP_ASSET_TYPE, MAPS_EXPORT_INFO_ASSET_TYPE} from "#material-outputs-filenames/types"
import {DataObjectAssignmentType} from "@cm/utils/data-object-assignment"

export const organizationName = "infected" as const

const options: FilenameSchemaEntry["options"] = {
    imageFormatSpelling: {
        tiff: "tif",
    },
}

export const schemas: FilenameSchemaEntry[] = [
    // maps exports
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "$MATERIAL_ARTICLE_ID$_$MATERIAL_NAME$_v$MATERIAL_REVISION_NUMBER$",
    },

    // maps exports maps
    {
        type: MAPS_EXPORT_MAP_ASSET_TYPE,
        schema: "$MATERIAL_NAME$_$MAP_TYPE$.$EXPORT_FORMAT$",
        options,
    },

    // maps exports info
    {
        type: MAPS_EXPORT_INFO_ASSET_TYPE,
        schema: "$MATERIAL_NAME$_info.$INFO_FILE_FORMAT$",
    },
]
